import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Button, Grid, Select, MenuItem, FormControl, Typography } from '@material-ui/core'
import BackgroundImage from './images/iStock-695360068.jpg';
import { useFormInput, useFormInputClear } from './CustomHooks';
import axios from 'axios';
import { handleAxiosError, getAPIUrl } from './AppUtils';

const inputWidth = 300
const styles = theme => ({
    background: {
        backgroundSize: "cover",
        backgroundImage: `url(${BackgroundImage})`,
        height: "90vh",
        width: "100%"
    },
    gridContainer: {
        height: "100%",
        width: "100%",
        paddingTop: 65,
    },
    companyLogo: {
        borderRadius: 5,
        width: inputWidth,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e2e2e2",
        backgroundColor: "#FFF",
    },
    formControl: {
        width: inputWidth-2,
        backgroundColor: "#FFF",
        borderRadius: 5,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e2e2e2"
    },
    option: {
        // overflow: "hidden",
    },
    select: {
        color: "#555555",
        fontSize: 14,
    },
    startButton: {
        width: inputWidth,
    },
    startDisabled:{
        width: inputWidth,
        opacity: 0.6,
        '&:hover': {
            cursor: "not-allowed",
        },
    }
});

function StartPage(props) {
    const { classes, logo } = props;
    const source = axios.CancelToken.source();
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const hospital = useFormInput("");
    const [departments, setDepartments] = useState([]);
    const [startDisabled, setStartDisabled] = useState(false);
    const [filters, setFilters] = useState([]);
    const [department,setDepartment] = useState(undefined);
    const [filterChoice, setFilterChoice] = useState({});
    const [departmentDisabled, setDepartmentDisabled] = useState(true);
    const [filterOptions, setFilterOptions] = useState(undefined);
    const [departmentAlias, setDepartmentAlias] = useState('');
    //mount, unmount
    useEffect(() => {
        getStartPageOptions();
        if(props.adminView){
            props.setAdminView(false);
        }
        return () => {source.cancel("unmount");}
    }, []);
    useEffect(() => {
        if(filters.length > 0 && filters.every(n=>filterChoice[n.info.key])){
            let filteredDepartments = departments.filter(n=>
                filters.every(filter=>parseInt(n[filter.info.key])===parseInt(filterChoice[filter.info.key]))
            )
            setDepartmentOptions(filteredDepartments)
            if(filteredDepartments.length===0){
                setDepartmentDisabled(true);
                setDepartment("");
            }
            else if(filteredDepartments.length===1){
                setDepartmentDisabled(false);
                setDepartment(filteredDepartments[0].id)
            }
            else{
                setDepartmentDisabled(false);
                setDepartment("");
            }
        }
        else{
            setDepartmentDisabled(true);
            setDepartment("");
        }
    },[filterChoice])
    useEffect(() => {
        if(parseInt(department)>0){
            let selectedDepartment = departmentOptions.find(n=>n.id.toString()===department.toString())
            props.setDepartmentInfo({
                labels: filters.map((n,i)=>{
                    return n.info.name + ': ' + filterOptions[i].find(m=>parseInt(m.id)===parseInt(filterChoice[n.info.key])).name;
                }).concat([departmentAlias + ': ' + selectedDepartment.name]),
                departmentId: selectedDepartment.id,
                hospitalId: selectedDepartment.hospital,
            });
        }
        else{
            props.setDepartmentInfo(undefined);
        }
    },[department]);
    useEffect(() => {
        if(props.departmentInfo){
            setStartDisabled(false);
        }
        else{
            setStartDisabled(true);
        }
    },[props.departmentInfo])
    function getStartPageOptions() {
        axios.get(getAPIUrl()+'/startPageOptions',{cancelToken: source.token})
        .then(response => {
            setFilterOptions(response.data.filters.map((n,i)=>{
                if(i===0){
                    return n.options
                }
                else{
                    return [];
                }
            }))
            setFilters(response.data.filters);
            setDepartments(response.data.departments);
            setDepartmentAlias(response.data.department_alias)
        })
        .catch(error=>handleAxiosError(error));
    }
    function goToCreateStatusReport(event) {
        if(!startDisabled){
            props.history.push("/emstatrep");
        }
    }
    function handleFilterChange(index, key, e){
        let newFilterChoice = {
            ...filterChoice,
            [key]: e.target.value
        }
        var newFilterOptions = filterOptions.slice();
        filters.slice(index+1).forEach((n,i)=>{
            newFilterChoice[n.info.key]="";
            if(i===0){
                //filter subsequent option to show only still possible options
                let relevantFilters = filters.slice(0,index+1);
                let possibleOptions = departments.filter(n=>
                    relevantFilters.every(filter=>parseInt(n[filter.info.key])===parseInt(newFilterChoice[filter.info.key]))
                ).reduce((obj,n)=>{
                    obj[n[filters[index+1].info.key]] = true;
                    return obj
                },{});
                newFilterOptions[index+1] = filters[index+1].options.filter(n=>possibleOptions[n.id]);
            }
            else{
                newFilterOptions[index+1+i] = [];
            }
        });
        setFilterOptions(newFilterOptions);
        setFilterChoice(newFilterChoice);
    }
    return (
        <div className={classes.background}>
            <Grid className={classes.gridContainer} container direction='column' justify='flex-start' 
                alignItems='center' spacing={2}
            >
                <Grid item>
                    <img className={classes.companyLogo}
                        src={logo}
                        alt=''
                    />
                </Grid>
                {filters.map((n,i)=>
                <Grid item key={n.info.key}>
                    <FormControl className={classes.formControl}>
                        <Select
                            className={classes.select}
                            disableUnderline 
                            native
                            onChange={e=>handleFilterChange(i,n.info.key,e)}
                            value={filterChoice[n.info.key]}
                            disabled={filterOptions[i].length===0}
                        >
                            <option className={classes.option} value="">
                                &nbsp;&nbsp;&nbsp;&nbsp;Select {n.info.name}
                            </option>
                            {filterOptions[i].map(option =>
                                <option key={option.id} className={classes.option} value={option.id}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;{option.name}
                                </option>)
                            }
                        </Select>
                    </FormControl>
                </Grid>
                )}
                <Grid item>
                    <FormControl className={classes.formControl}>
                        <Select
                            disabled={departmentDisabled}
                            className={classes.select}
                            disableUnderline 
                            native
                            value={department}
                            onChange={e=>setDepartment(e.target.value)}
                        >
                            <option className={classes.option} value="">
                                &nbsp;&nbsp;&nbsp;&nbsp;Select {departmentAlias}
                            </option>
                            {departmentOptions.map(option =>
                                <option key={option.id} className={classes.option} value={option.id}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;{option.name}
                                </option>)
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item>
                    <Button className={startDisabled?classes.startDisabled:classes.startButton} color="secondary"
                        variant="contained"
                        onClick = {goToCreateStatusReport} 
                    >
                        Start
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
}

export default withStyles(styles)(StartPage);